module.exports = __webpack_public_path__ + "static/media/MOON.c97e27a8.png";